export const LEVEL_WIDTH = 374;
export const SIDE_WIDTH = 568;
export const INPUT_WIDTH = SIDE_WIDTH / 2 - 8;
export const SCRIPT_INPUT_HEIGHT = 528;
// dashed border hack from https://kovart.github.io/dashed-border-generator/
export const DASHED_BORDER = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='%23001B5366' stroke-width='1' stroke-dasharray='10%2c8' stroke-dashoffset='10' stroke-linecap='round'/%3e%3c/svg%3e");
border-radius: 6px;`;

export const AI_TOOLTIP = {
  MESSAGE_CATEGORY:
    'Select the type of message you’d like Covideo AI Assist to create. You can also enter your own if it’s not included in the dropdown.',
  CUSTOMER_NAME:
    'Enter the name of the person or persons you’re sending your message to.',
  CTA: 'Briefly describe what you would like your recipient to do next. Ex: “Call me back”, “Click the button”, or “Write a review”.',
  ADDITIONAL_INFO:
    'Include any additional information you’d like Covideo AI Assist to consider.',
};
